import { defineMessages } from 'react-intl';

export const messages: {
	repeat: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextRun: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextRunAt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	delete: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	edit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	repeat: {
		id: 'conversation-assistant-ui-components.scheduled-chat-preview-card.repeat',
		defaultMessage: 'Repeat',
		description: 'Label for the recurrence row in the scheduled chat preview card.',
	},
	nextRun: {
		id: 'conversation-assistant-ui-components.scheduled-chat-preview-card.next-run',
		defaultMessage: 'Next run',
		description: 'Label for the next-run row in the scheduled chat preview card.',
	},
	nextRunAt: {
		id: 'conversation-assistant-ui-components.scheduled-chat-preview-card.next-run-at',
		defaultMessage: 'Next run {nextRunLabel}',
		description: 'Subtitle in the scheduled chat preview card header.',
	},
	delete: {
		id: 'conversation-assistant-ui-components.scheduled-chat-preview-card.delete',
		defaultMessage: 'Delete',
		description: 'Secondary action in the scheduled chat preview card footer.',
	},
	edit: {
		id: 'conversation-assistant-ui-components.scheduled-chat-preview-card.edit',
		defaultMessage: 'Edit',
		description: 'Primary action in the scheduled chat preview card footer.',
	},
});
